import http from '@/biz/http.mjs'

export default {
    read: ({prjId, sVer}) => http.get('/onePrjBaseline', {prjId, sVer}),

    readList: ({
        isDesc,
        pblProgress,
        pblStsCodes,
        pblType,
        prjId,
        prjPatternId,
    }) => http.get(
        '/prjbaselines',

        {
            isDesc,
            pblProgress,
            pblStsCodes,
            pblType,
            prjId,
            prjPatternId,
        }
    ),
}
